import { render } from "./Participants.vue?vue&type=template&id=80c9bfca"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"

import "./Participants.vue?vue&type=style&index=0&id=80c9bfca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__